/* eslint-disable */
'use strict'
const prischool = {
  grade16: ['ថ្នាក់ទី១', 'ថ្នាក់ទី២', 'ថ្នាក់ទី៣', 'ថ្នាក់ទី៤', 'ថ្នាក់ទី៥', 'ថ្នាក់ទី៦'],
  qemissubject: ['ភាសាខ្មែរ', 'គណិតវិទ្យា', 'សិក្សាសង្គម', 'វិទ្យាសាស្ត្រ']
}

module.exports = prischool
